import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="PWA Weather Application" link="https://github.com/imrudrakarmakar/Weather_PWA" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Progressive Weather Application created using React.js and Open Weather API.
    </ProjectCard>
    <ProjectCard title="React Keeper App" link="https://github.com/imrudrakarmakar/KeeperApp" bg="linear-gradient(to right, #43CEA2 0%, #185A9D 100%)" mdxType="ProjectCard">
A Keeper website like Google Keep created using React.js.
    </ProjectCard>
    <ProjectCard title="Dynamic Blog" link="https://github.com/imrudrakarmakar/BlogPage" bg="linear-gradient(to right, #02AAB0 0%, #00CDAC 100%)" mdxType="ProjectCard">
Full Dynamic Blog Website with Reading, Write and Delete functions. The technology used HTML, CSS, JavaScript, Node.js, Express.js, MongoDB, Mongoose.
    </ProjectCard>
    <ProjectCard title="Dynamic ToDo App" link="https://github.com/imrudrakarmakar/TodoListDB" bg="linear-gradient(to right, #CC2B5E 0%, #753A88 100%)" mdxType="ProjectCard">
Full Dynamic TodoList Website with Reading, Write and Delete functions. The technology used HTML, CSS, JavaScript, Node.js, Express.js, MongoDB, Mongoose.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      